import Vue from 'vue'
import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import responseHandler from "@/plugins/errorHandling";
import {IPromotion} from "@/model/Service/promotionInterfaces";

interface ServiceProviderPromotionState {
  promotions: IPromotion[];
  promotion: IPromotion;
  errors: IErrors;
}

const state: ServiceProviderPromotionState = {
  promotions: [],
  promotion: {} as IPromotion,
  errors: {},
};

const getters: GetterTree<ServiceProviderPromotionState, RootState> = {
  promotions: (state) => state.promotions,
  promotion: (state) => state.promotion,
  errors: (state) => state.errors,
};

const actions: ActionTree<ServiceProviderPromotionState, RootState> = {
  fetchPromotions: ({ commit }, data: { spId: number }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/promotions',
      method: "GET",
    }),
    commit,
    'promotionsLoaded'
  ),
  fetchPromotion: ({ commit }, data: { spId: number, promotionId: number }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/promotions/' + data.promotionId,
      method: "GET",
    }),
    commit,
    'promotionLoaded'
  ),
  createPromotion: ({ commit }, data: { spId: number, promotion: Partial<IPromotion> }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/promotions',
      method: "POST",
      data: data.promotion,
    }),
    commit,
    'promotionCreated'
  ),
  updatePromotion: ({ commit }, data: { spId: number, promotionId: number, promotion: Partial<IPromotion> }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/promotions/' + data.promotionId,
      method: "PATCH",
      data: data.promotion,
    }),
    commit,
    'promotionUpdated'
  ),
  deletePromotion: ({ commit }, data: { spId: number, promotionId: number }): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + data.spId + '/promotions/' + data.promotionId,
      method: "DELETE",
    }),
    commit,
    'promotionDeleted'
  ),
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
  cleanError: ({commit}, index: any): any => {
    commit('cleanError', index);
  },
};

const mutations: MutationTree<ServiceProviderPromotionState> = {
  promotionsLoaded(state, payload) {
    state.promotions = payload;
  },
  promotionLoaded(state, payload) {
    state.promotion = payload;
  },
  promotionCreated(state, payload) {
    state.promotion = payload;
  },
  promotionUpdated(state, payload) {
    state.promotion = payload;
  },
  promotionDeleted() {
    // handled by navigation
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
  cleanError(state, index: string) {
    Vue.delete(state.errors, index);
  },
};

const namespaced: boolean = true;

export const serviceProviderPromotionModule: Module<ServiceProviderPromotionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
